const generateMarkup = component => {
  let defaultJson = {};
  if (!component) return defaultJson;

  let blocks = [
    { data: { text: component.selector }, type: "header" },
    {
      data: {
        text: `This is an auto-generated page created for <strong>${component.selector}</strong> component. You can document instructions on how to use this component and it's different variations and states here. This will be added to your style guide for developers.`
      },
      type: "paragraph"
    },
    {
      data: {
        text: "You can add, remove or modify any instructions or examples here."
      },
      type: "paragraph"
    }
  ];
  component.htmlMarkup.forEach(h => {
    blocks.push({
      type: "delimiter",
      data: {}
    });
    blocks.push({
      data: {
        text: h.selector
      },
      type: "header"
    });
    blocks.push({
      data: {
        code: h.html
      },
      type: "code"
    });
  });

  defaultJson = {
    time: new Date().getTime(),
    blocks: blocks,
    version: "2.16.1"
  };

  return defaultJson;
};

export default generateMarkup;
